import { collectCmdSlugs, toMergeableCmdData } from "./assignOperationalFormTask";

export const NOTIFY_PANEL_FAILURE_CMD = "notify-panel-failure";

const NOTIFY_PANEL_FAILURE_SLUGS = new Set(["notify_panel_failure"]);

export function isNotifyPanelFailureCmd(data) {
  return collectCmdSlugs(data).some((slug) =>
    NOTIFY_PANEL_FAILURE_SLUGS.has(slug)
  );
}

export function isNotifyPanelFailureStackEntry(entry) {
  if (!entry || entry.type !== "cmd") {
    return false;
  }
  return isNotifyPanelFailureCmd(entry);
}

export function payloadContainsNotifyPanelFailure(cmdPayload) {
  if (!cmdPayload || typeof cmdPayload !== "object") {
    return false;
  }
  if (isNotifyPanelFailureCmd(cmdPayload)) {
    return true;
  }
  const stack = cmdPayload.filled_stack;
  if (!Array.isArray(stack)) {
    return false;
  }
  return stack.some(isNotifyPanelFailureStackEntry);
}

export function readNotifyPanelFailureComment(data) {
  if (!data || typeof data !== "object") {
    return "";
  }
  const value = data.comment ?? data.input;
  return typeof value === "string" ? value.trim() : "";
}

/**
 * The default comment comes from whatever the flow node was configured with, so
 * the operator sees it prefilled and can edit it before notifying.
 */
export function resolveNotifyPanelFailureDefaultComment(nodeData) {
  if (!nodeData || typeof nodeData !== "object") {
    return "";
  }
  const stack = Array.isArray(nodeData.filled_stack) ? nodeData.filled_stack : [];
  const sources = [
    ...stack.filter(isNotifyPanelFailureStackEntry).map((entry) => entry.data),
    nodeData.data,
    nodeData.storage,
    nodeData,
  ];
  for (const source of sources) {
    const comment = readNotifyPanelFailureComment(source);
    if (comment) {
      return comment;
    }
  }
  return "";
}

export function mergeNotifyPanelFailureComment(payload, comment) {
  const normalized = typeof comment === "string" ? comment.trim() : "";

  const apply = (value) => {
    const target = toMergeableCmdData(value);
    if (normalized) {
      target.comment = normalized;
    } else {
      delete target.comment;
    }
    return target;
  };

  if (isNotifyPanelFailureCmd(payload)) {
    if (payload.storage) {
      payload.storage = apply(payload.storage);
    }
    payload.data = apply(payload.data);
  }

  const stack = payload.filled_stack;
  if (Array.isArray(stack)) {
    stack.forEach((entry) => {
      if (isNotifyPanelFailureStackEntry(entry)) {
        entry.data = apply(entry.data);
      }
    });
  }
}
